import React from 'react';

const Footer = () => {
  return (
    <footer className='footer py-3 bg-dark text-white'>
      <div className='container'>
        <figure className='text-center'>
          <h5>
            Made with{' '}
            <span className='heart'>
              <img
                draggable='false'
                title=':heart:'
                alt='❤'
                src='https://twemoji.maxcdn.com/2/svg/2764.svg'
                className='emoji'
                style={{ height: '1.2em' }}
              />
            </span>{' '}
            in India
          </h5>
        </figure>
      </div>
    </footer>
  );
};

export default Footer;
